<template>
    <section
        :class="`calendar-layout patient-calendar ${listView === CalendarViewTypeEnum.Map || isPatientLoading ? 'h-100' : ''}`"
    >
        <CalendarFilters
            v-if="listView !== CalendarViewTypeEnum.Map"
            :listView="listView"
            :isPatientCalendar="true"
            :startDate="startDate"
            :endDate="endDate"
            :patientsList="patientsList"
            :updateDateRange="updateDateRange"
            :patientRefresh="patientRefresh"
            :handleViewChange="handleViewChange"
            :showMainHeader="showMainHeader"
        />
        <section
            :class="`calendar-content  d-${listView !== CalendarViewTypeEnum.Map ? 'flex' : 'none'} flex-column mb-4`"
        >
            <Pagination
                ref="patientCalendarPagination"
                entity="patients"
                classes="pagination-footer"
                :pageChanged="pageChanged"
                :isLoading="isPatientLoading"
                :pageSize="pageSize"
                v-on:updatePageSizeChanged="updatePageSizeChanged"
                :showPageSizeOptions="false"
            >
                <section class="pagination-main">
                    <div
                        class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                        v-if="isPatientLoading"
                    >
                        <i class="fas fa-calendar-alt fa-7x animate-flash mb-3"></i>
                        <h4>Loading Patient Calendar...</h4>
                    </div>
                    <template v-if="!getHasData || isError">
                        <div
                            class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                            v-if="!getHasData && !isPatientLoading"
                        >
                            <span class="font-size-3xl"> No Patients Found. </span>
                        </div>
                        <div
                            class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                            v-if="isError"
                        >
                            <p>There was an error while fetching the patients list.<br />Please try again.</p>
                            <button class="btn btn-primary btn-sm" @click="pageReset()">Try Again</button>
                        </div>
                    </template>
                    <PatientCalendarContent
                        :startDate="startDate"
                        :endDate="endDate"
                        :patientsList="patients"
                        :tasksList="tasks"
                        :tasksMap="tasksMap"
                        v-on:calendarRefresh="taskRefresh"
                    />
                </section>
                <template v-if="getHasData" v-slot:legend>
                    <div class="d-flex flex-wrap ms-auto align-items-center">
                        <div class="d-flex align-items-center me-2">
                            <i class="legend ax-calendar-event legend-success me-1"></i>
                            <span>Completed</span>
                        </div>
                        <div class="d-flex align-items-center me-2">
                            <i class="legend ax-calendar-event legend-danger me-1"></i>
                            <span>Missed</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="legend ax-calendar-event legend-warning me-1"></i>
                            <span>Unassigned Visits</span>
                        </div>
                        <div class="d-flex align-items-center ms-2">
                            <i class="fa fa-home fa-md me-1 cursor pointer"></i>
                            <span>EVV Statuses</span>
                            <a
                                href="javascript:void(0);"
                                role="button"
                                v-custom-popover="{
                                    content: tooltip,
                                    placement: 'top',
                                    className: 'w-10 font-size-sm '
                                }"
                            >
                                <i class="fas fa-info-circle text-primary ms-1"></i>
                            </a>
                        </div>
                    </div>
                </template>
            </Pagination>
        </section>
        <section class="d-flex h-100" v-if="listView === CalendarViewTypeEnum.Map" style="height: 100%">
            <EmployeeMap :listView="listView" :isPatientCalendar="true" :handleViewChange="handleViewChange" />
        </section>
    </section>
</template>

<style src="./PatientCalendar.scss"></style>
<script src="./PatientCalendar.ts"></script>
